import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuthContext} from 'packages/common/hooks';
import {checkAccess} from 'packages/common/utils/rolesConfig';
import {paths} from 'packages/common/routes/paths';
import {PRE_AUTH_PATH_KEY} from 'packages/common/utils/sessionStorageKeys';

export const useRedirectAfterAuth = () => {
  const navigate = useNavigate();
  const {isAuthenticated, userRole, loading} = useAuthContext();

  useEffect(() => {
    const handleRedirect = () => {
      if (loading || !isAuthenticated || !userRole) {
        return;
      }

      const preAuthPath = localStorage.getItem(PRE_AUTH_PATH_KEY);

      if (preAuthPath) {
        localStorage.removeItem(PRE_AUTH_PATH_KEY);

        const isAdminPath = preAuthPath.startsWith(paths.admin.root);
        const isAppPath = preAuthPath.startsWith(paths.app.root);

        if ((isAdminPath && checkAccess(userRole, paths.admin.root)) ||
            (isAppPath && checkAccess(userRole, paths.app.root))) {
          navigate(preAuthPath);
          return;
        }
      }

      // Redirection basée sur le rôle
      if (checkAccess(userRole, paths.admin.root)) {
        navigate(paths.admin.root, {replace: true});
      } else if (checkAccess(userRole, paths.app.root)) {
        navigate(paths.app.dashboard, {replace: true});
      } else {
        navigate('/', {replace: true});
      }
    };

    handleRedirect();
  }, [isAuthenticated, userRole, loading, navigate]);
};
